<template>
    <CompassDialog
        :visible.sync="isVisible"
        :title="dialogTitle"
        size="small"
        :closeOnClickOverlay="false"
        @closed="$emit('close')"
    >
        <template slot="default">
            <p
                class="typographies-paragraph-medium-regular activities-dialog__content"
                v-html="dialogContent"
            />
        </template>
        <section slot="footer" class="activity-delete-dialog-footer__container">
            <CompassButton
                type="secondary"
                :label="cancelButtonLabel"
                :disabled="pending"
                @click="$emit('close')"
            />
            <CompassButton
                :loading="pending"
                type="primary-destructive"
                :label="confirmButtonLabel"
                @click="onDelete"
            />
        </section>
    </CompassDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('activitiesStores');
export default {
    props: {
        activity: {
            type: Object,
            required: true,
        },
        callback: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            isVisible: true,
            confirmButtonLabel: this.$l10n.__('Supprimer'),
            cancelButtonLabel: this.$l10n.__('Annuler'),
            dialogTitle: this.$l10n.__('Supprimer une activité'),
            pending: false,
        };
    },
    computed: {
        dialogContent() {
            return this.$l10n.__(
                'Vous êtes sur le point de supprimer l’activité%(activityTitle)s. %(br)s Cette action est définitive.',
                {
                    activityTitle: this.activity?.title ? `<b> ${this.activity?.title}</b>` : '',
                    br: '<br />',
                },
            );
        },
    },
    mounted() {
        this.isVisible = true;
    },
    methods: {
        ...mapActions(['deleteActivity']),
        onDelete() {
            this.pending = true;
            this.deleteActivity(this.activity)
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        unique: true,
                        text: this.$l10n.__('L’activité%(activityTitle)s a été supprimée.', {
                            activityTitle: ` ${this.activity?.title}` ?? '',
                        }),
                    });
                    this.callback();
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        unique: true,
                        text: this.$l10n.__(
                            'Une erreur est survenue, merci de réessayer plus tard',
                        ),
                    });
                })
                .finally(() => {
                    this.$emit('close');
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.activity-delete-dialog {
    &__content {
        margin: 0;
    }
    &-footer__container {
        display: flex;
        justify-content: end;
        gap: var(--spacing-3);
        padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
    }
}
</style>
<style>
.page-activities-crm-listing-all .compass-panel {
    z-index: 999;
}
</style>
